import { ActionMenu } from '@ijoin/components';
import { AnnuityCarrierExportRes } from '@ijoin/hooks';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { useToggle } from 'usehooks-ts';

import { EditFileIdentifierDialog } from './EditFileIdentifierDialog';

export const CarrierExportActionsCell = (props: {
  annuityIntegrationId: string;
  exportRow: AnnuityCarrierExportRes;
}) => {
  const [isDialogOpen, toggleDialogOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Edit', onSelect: toggleDialogOpen }]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actions-carrierExport-${props.exportRow.id}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      {isDialogOpen && (
        <EditFileIdentifierDialog
          annuityIntegrationId={props.annuityIntegrationId}
          exportRow={props.exportRow}
          onClose={toggleDialogOpen}
        />
      )}
    </>
  );
};
